module.exports = new Promise(function(resolve) {
    var scope = "crmApp";
    if (typeof window[scope] !== "undefined") return resolve(window[scope]);
    var resolved = false;
    function done(container) {
      if (resolved) return;
      resolved = true;
      resolve(container);
    }
    function unavailable(reason) {
      var error = new Error("[MF] Cannot load " + scope + ": " + reason);
      done({
        get: function() { return Promise.reject(error); },
        init: function() {}
      });
    }
    var timer = setTimeout(function() {
      unavailable("connection timed out");
    }, 3000);
    var script = document.createElement("script");
    script.src = "__CRM_REMOTE_URL__";
    script.async = true;
    script.onload = function() {
      clearTimeout(timer);
      if (window[scope]) {
        done(window[scope]);
      } else {
        unavailable("container not found");
      }
    };
    script.onerror = function() {
      clearTimeout(timer);
      unavailable("connection failed");
    };
    document.head.appendChild(script);
  });